import { FormWrapper } from 'components/formWrapper/formWrapper'
import { LoadingContainer } from 'components/loadingContainer'
// eslint-disable-next-line no-restricted-imports
import { CustomerForm } from 'features/user/Ticket/customer'
import { useEventById } from 'hooks/admin/useEvents'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export const CustomerFormPage: React.FC = () => {
    const navigate = useNavigate()
    const { eventId } = useParams<{ eventId?: string }>()
    const { data, isLoading, error } = useEventById(eventId || '')
    const handleClose = () => {
        navigate('/')
    }

    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            <meta name="robots" content="noindex, nofollow" />
            <FormWrapper onClose={handleClose}>{data && <CustomerForm currentEvent={data} />}</FormWrapper>
        </LoadingContainer>
    )
}
